export const getEditorPrintPages = (json, tabs) => {
    if (!json || typeof json !== 'object') return [];
    const entries = Object.entries(json).filter(([, item]) => item?.type === 'caixa' || item?.type === 'text');
    if (!entries.length) return [];
    if (!tabs?.length) return [{ name: 'Plantilla', entries }];

    const defaultTab = tabs.find(tab => tab.toLowerCase() === 'pinya') || tabs[0];
    return tabs.map(name => ({
        name,
        entries: entries.filter(([, item]) => (item.pestanya || defaultTab).toLowerCase() === name.toLowerCase())
    })).filter(page => page.entries.length);
};

export const fitPrintBounds = (bounds, width, height, padding = 12) => {
    if (!bounds || width <= 0 || height <= 0) return { scale: 1, x: 0, y: 0 };
    const drawingWidth = bounds.right - bounds.left;
    const drawingHeight = bounds.bottom - bounds.top;
    const scale = Math.min(width / (drawingWidth + padding * 2), height / (drawingHeight + padding * 2));
    return {
        scale,
        x: (width - drawingWidth * scale) / 2 - bounds.left * scale,
        y: (height - drawingHeight * scale) / 2 - bounds.top * scale
    };
};

// Measure the unscaled DOM, including rotated boxes, badges, overflowing text
// and trunk supplements. Viewport zoom/pan never enters these coordinates.
export const measurePrintBounds = scene => {
    const origin = scene.getBoundingClientRect();
    let bounds = null;
    const include = rect => {
        if (!rect.width && !rect.height) return;
        const next = {
            left: rect.left - origin.left,
            top: rect.top - origin.top,
            right: rect.right - origin.left,
            bottom: rect.bottom - origin.top
        };
        bounds = bounds ? {
            left: Math.min(bounds.left, next.left), top: Math.min(bounds.top, next.top),
            right: Math.max(bounds.right, next.right), bottom: Math.max(bounds.bottom, next.bottom)
        } : next;
    };
    scene.querySelectorAll('*').forEach(element => include(element.getBoundingClientRect()));
    const walker = document.createTreeWalker(scene, NodeFilter.SHOW_TEXT);
    const range = document.createRange();
    while (walker.nextNode()) {
        if (!walker.currentNode.textContent.trim()) continue;
        range.selectNodeContents(walker.currentNode);
        if (range.getBoundingClientRect) include(range.getBoundingClientRect());
    }
    return bounds;
};
